// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3lbtU","signatureBlock":"Footer_signatureBlock__3sEvU","signature":"Footer_signature__33W7V"};